import handleError from "utils/handleError";
import Notification from "utils/notifications";
import { getFaqsClient } from "utils/web-api";
import {
  FaqClientActionTypes,
  setFaqClientList,
  setFaqClientLoadingList,
} from "store/reducers/faqClient.reducer";
import { takeEvery, call, put, all } from "redux-saga/effects";

function* asyncFaqList() {
  try {
    yield put(setFaqClientLoadingList(true));

    const response = yield call(getFaqsClient);

    const items = (response || []).map((f) => ({
      id: f.id,
      question: f.question,
      answer: f.answer,
    }));

    yield put(setFaqClientList({ items, total: items.length }));
  } catch (error) {
    handleError(error);
    Notification("error", "Erro ao carregar FAQs.");
    yield put(setFaqClientList({ items: [], total: 0 }));
  } finally {
    yield put(setFaqClientLoadingList(false));
  }
}

export default function* FaqClientSaga() {
  yield all([takeEvery(FaqClientActionTypes.ASYNC_LIST, asyncFaqList)]);
}
